export default __webpack_public_path__ + "static/media/Crocodile Claw Ring.6c410031.jpg";